export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const PRODUCT_IMAGE =
    "https://customer-assets.emergentagent.com/job_confidence-coach-43/artifacts/rhe9ad8b_2D58A7F7-53CB-4E6C-AC97-5A14ADA895EC.png";

export const LOGO_IMAGE =
    "https://customer-assets.emergentagent.com/job_confidence-coach-43/artifacts/4lav9qzo_006CA3E6-65AC-44D8-9165-44F6C6A3E95C.png";

export const TAGLINE = "The White Pill System™";

export const NAV_LINKS = [
    { label: "Home", to: "/" },
    { label: "Program", to: "/program" },
    { label: "How It Works", to: "/how-it-works" },
    { label: "Results", to: "/results" },
    { label: "Pricing", to: "/pricing" },
    { label: "FAQ", to: "/faq" },
];

export const HERO_IMAGE =
    "https://images.unsplash.com/photo-1453396450673-3fe83d2db2c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxtYW4lMjBhZGp1c3RpbmclMjBzdWl0JTIwdGllJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4MTIxNTk1OHww&ixlib=rb-4.1.0&q=85";

export const PILLAR_IMAGE_MINDSET = "/solution-man.png";

export const PILLAR_IMAGE_LIFESTYLE =
    "https://images.unsplash.com/photo-1633366147060-ce9e1a9fd39c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxtYW4lMjBhZGp1c3RpbmclMjBzdWl0JTIwdGllJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4MTIxNTk1OHww&ixlib=rb-4.1.0&q=85";

export const TESTIMONIAL_AVATARS = [
    "https://images.unsplash.com/photo-1769636929231-3cd7f853d038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBoZWFkc2hvdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MTIxNTk2NHww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1758534063829-a72058381e21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBoZWFkc2hvdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MTIxNTk2NHww&ixlib=rb-4.1.0&q=85",
];

export const TESTIMONIALS = [
    {
        name: "Marcus, 29",
        role: "Software Engineer · Austin, TX",
        avatar: TESTIMONIAL_AVATARS[0],
        quote:
            "I used to overthink every text and conversation. After 90 days I stopped chasing — women started reaching out to me. The mindset work was the real unlock.",
    },
    {
        name: "Daniel, 34",
        role: "Founder · London, UK",
        avatar: TESTIMONIAL_AVATARS[1],
        quote:
            "This wasn't a 'pickup' program. It rebuilt me. Discipline, frame, presence. I walk into rooms differently now — and my dating life finally reflects that.",
    },
    {
        name: "Jordan, 26",
        role: "Sales Lead · Toronto, CA",
        avatar: TESTIMONIAL_AVATARS[0],
        quote:
            "By Day 60 I was on more dates than I'd had in two years combined. The structure forced me to do the things I'd been avoiding for a decade.",
    },
];

export const PILLARS = [
    {
        no: "01",
        title: "Masculinity",
        sub: "Build Strength, Confidence & Leadership",
        desc:
            "Reclaim grounded masculine energy — the foundation every other skill stacks on. Posture, voice, frame, decisiveness.",
    },
    {
        no: "02",
        title: "Sexual Intelligence",
        sub: "Understand Attraction, Tension & Desire",
        desc:
            "How attraction actually works — at the level of frame, energy, and polarity. No scripts. Just calibrated awareness.",
    },
    {
        no: "03",
        title: "Abundance Mindset",
        sub: "Stop Chasing & Create Options",
        desc:
            "Kill scarcity at the root. Build the inner certainty, options, and lifestyle that make outcome-dependency impossible.",
    },
    {
        no: "04",
        title: "Preselection",
        sub: "Become the Man Women Choose",
        desc:
            "Engineer the signals — social proof, status cues, lifestyle, network — that make you the obvious choice in a room.",
    },
];

export const PHASES = [
    {
        range: "Days 1 – 30",
        title: "Rebuild Your Mindset",
        bullets: [
            "Kill the scarcity mindset and outcome dependency",
            "Daily confidence and identity work",
            "Reset your relationship with rejection",
            "Define the man you're building",
        ],
    },
    {
        range: "Days 31 – 60",
        title: "Improve Attraction & Social Skills",
        bullets: [
            "Conversation frame, voice, and presence",
            "Approach anxiety — neutralized through reps",
            "Texting, dating dynamics, and attraction principles",
            "Style, grooming, and physical standards",
        ],
    },
    {
        range: "Days 61 – 90",
        title: "Become Consistent & Relationship-Ready",
        bullets: [
            "Lead dates with calm masculine energy",
            "Filter, qualify, and choose — stop chasing",
            "Build a lifestyle women want to be part of",
            "Sustain the standard long after the program ends",
        ],
    },
];

export const FOR_LIST = [
    "Men 21–45 who are serious about transformation",
    "Stuck in a dating dry-spell or repeating the same patterns",
    "Recently single and ready to rebuild from the ground up",
    "High-performers who win in career but lose in dating",
    "Tired of advice from the internet — ready for a structured 90-day plan",
];

export const NOT_FOR_LIST = [
    "Men looking for cheap tricks, lines, or 'pickup' tactics",
    "Anyone who refuses to do the inner work",
    "Men hoping for guarantees on attracting specific women",
    "Anyone unwilling to commit ~5 focused hours per week",
    "Looking for a magic pill instead of a real transformation",
];

export const MODULES = [
    {
        no: "01",
        title: "Masculinity",
        sub: "Build Strength, Confidence & Leadership",
        desc:
            "Reclaim grounded masculine energy — the foundation every other skill stacks on. Posture, voice, frame, decisiveness.",
    },
    {
        no: "02",
        title: "Sexual Intelligence",
        sub: "Understand Attraction, Tension & Desire",
        desc:
            "How attraction actually works — at the level of frame, energy, and polarity. No scripts. Just calibrated awareness.",
    },
    {
        no: "03",
        title: "Abundance Mindset",
        sub: "Stop Chasing & Create Options",
        desc:
            "Kill scarcity at the root. Build the inner certainty, options, and lifestyle that make outcome-dependency impossible.",
    },
    {
        no: "04",
        title: "Preselection",
        sub: "Become the Man Women Choose",
        desc:
            "Engineer the signals — social proof, status cues, lifestyle, network — that make you the obvious choice in a room.",
    },
];

export const FAQS = [
    {
        q: "Is this a pickup artist program?",
        a:
            "No. This is personal development applied to dating. We don't teach scripts, routines, or manipulation. We build the man — confidence, presence, lifestyle, frame — so attraction becomes a byproduct of who you are.",
    },
    {
        q: "Do you guarantee results with women?",
        a:
            "We don't make outcome guarantees about other people. What we guarantee is a structured 90-day process for building confidence, discipline, and dating clarity. The men who commit to the work see meaningful change in how they show up.",
    },
    {
        q: "How much time per week does it require?",
        a:
            "Plan on 4–6 focused hours per week — daily habits, weekly check-ins, and field work (real-world practice). The men who treat it like the priority it is get the biggest results.",
    },
    {
        q: "Is this 1-on-1 coaching or a group program?",
        a:
            "It's a hybrid: structured curriculum, weekly group calls, and direct accountability from a coach. You're not alone — you're with a brotherhood of men doing the work alongside you.",
    },
    {
        q: "I'm shy / introverted. Will this work for me?",
        a:
            "Yes. Most of our best transformations come from quiet, thoughtful men. The program is built around progression — we never throw you into the deep end. You'll build skills in graduated steps.",
    },
    {
        q: "What happens after I book a free consultation?",
        a:
            "You'll get on a 30-minute call with our team. We'll diagnose where you're stuck, explain how the program works, and decide together if it's the right fit. No pressure, no pitch — just clarity.",
    },
    {
        q: "What's the investment?",
        a:
            "We discuss pricing on the consultation call once we understand your situation. This is a premium coaching program for men who are serious about transformation.",
    },
];
